import rate1 from 'images/smiles/dissapointed_2.svg';
import rate2 from 'images/smiles/sad_2.svg';
import rate3 from 'images/smiles/neutral_2.svg';
import rate4 from 'images/smiles/liked_2.svg';
import rate5 from 'images/smiles/happy_2.svg';

import React from 'react';

export default function Icon({ rate }) {
  const getImage = () => {
    switch (rate) {
      case 1:
        return rate1;
      case 2:
        return rate2;
      case 3:
        return rate3;
      case 4:
        return rate4;
      case 5:
        return rate5;
      default:
        return null;
    }
  };

  if (rate == null) {
    return <div />;
  }

  return (
    <img src={getImage()} alt="icon" style={{ marginTop: '3px', marginBottom: '3px' }} />
  );
}
